import InfoOutlineIcon from '@mui/icons-material/InfoOutline'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Stack, Typography } from '@mui/material'
import { useCiboAutoForm } from './CiboAutoFormContext'

export const ValidationMessages = ({
  fieldName,
  error,
}: {
  fieldName: string
  error?: { message: string; keyword?: string }
}) => {
  const { warnings, touched, submitted } = useCiboAutoForm()

  const fieldError = error?.message
  const errorKeyword = error?.keyword
  const showError = !!fieldError && (touched[fieldName] || !!submitted)

  const fieldWarning = warnings?.[fieldName]
  const warningMessage = fieldWarning?.message
  const warningKeyword = fieldWarning?.keyword
  const showWarning = warningMessage && !showError && (touched[fieldName] || !!submitted)

  return (
    <>
      {showError && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          mt={0.5}
          data-testid={`validation-error-${fieldName}${errorKeyword ? `-${errorKeyword}` : ''}`}
        >
          <InfoOutlineIcon sx={{ fontSize: 14, color: 'error.main' }} />

          <Typography color="error.main" variant="caption">
            {fieldError}
          </Typography>
        </Stack>
      )}

      {showWarning && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          mt={0.5}
          data-testid={`validation-warning-${fieldName}${warningKeyword ? `-${warningKeyword}` : ''}`}
        >
          <WarningAmberIcon sx={{ fontSize: 14, color: 'warning.main' }} />

          <Typography color="warning.main" variant="caption">
            {warningMessage}
          </Typography>
        </Stack>
      )}
    </>
  )
}
